var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.09 70.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #996875;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #efd3d9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.05,
    cy: 35.05,
    r: 35.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.11,41.63l-9.53-9.53c-1.11-1.11-3.1-1.11-4.22,0l-9.53,9.53c-.89.89-1.09,2.2-.61,3.29.13.49.38.96.77,1.34.58.57,1.33.85,2.08.85s1.53-.29,2.11-.88l2.97-3.01c1.16-1.17,2.7-1.82,4.35-1.83h.02c1.64,0,3.18.64,4.34,1.8l3.05,3.05c1.16,1.16,3.04,1.16,4.19,0,.63-.63.91-1.48.85-2.31.06-.83-.22-1.67-.85-2.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.11,28.93l-9.53-9.53c-1.11-1.11-3.1-1.11-4.22,0l-9.53,9.53c-.89.89-1.09,2.2-.61,3.29.13.49.38.96.77,1.34.58.57,1.33.85,2.08.85s1.53-.29,2.11-.88l2.97-3.01c1.16-1.17,2.7-1.82,4.35-1.83h.02c1.64,0,3.18.64,4.34,1.8l3.05,3.05c1.16,1.16,3.04,1.16,4.19,0,.63-.63.91-1.48.85-2.31.06-.83-.22-1.67-.85-2.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTone);
export default __webpack_public_path__ + "static/media/UpTone.ca3a7be4a185bac2b2530b10ee22ee13.svg";
export { ForwardRef as ReactComponent };